module.exports = __webpack_public_path__ + "static/media/dinner.02cd247c.pdf";